<div class="modal-body">
    @for (item of signeringar; track item) {
    <rask-kontrakt-digitalsignering-item
        [signeringInfo]="item"
        [readonly]="true">
    </rask-kontrakt-digitalsignering-item>
    }
</div>
<div class="modal-footer">
    <rask-button color="secondary" (click)="dismiss()">Stäng</rask-button>
</div>